<script lang="ts">

const classMapping = {
    'size.large': 'btn-size-700',
    'size.medium': 'btn-size-500',
    'size.small': 'btn-size-400',
    'size.little': 'btn-size-300',
    'bg.primary': 'btn-bg-primary',
    'bg.secondary': 'btn-bg-secondary',
    'bg.mojito': 'btn-bg-mojito',
    'bg.text': 'btn-bg-text',
    'bg.aviation': 'btn-bg-aviation'
} as const;

type ClassMapping = typeof classMapping;
type KeyOfUnion<T> = T extends T ? keyof T : never;

type MatchKeys<Base, Conditions> = KeyOfUnion<Base> extends infer Key
    ? Key extends Conditions
        ? Key : never
    : never;

export type CommonButtonSizesType = MatchKeys<ClassMapping, `size.${string}`>;

export type CommonButtonColorType =
    | 'bg.primary'
    | 'bg.secondary'
    | 'bg.text'
    | 'bg.mojito'
    | 'bg.aviation';

const defaultColor = 'bg.primary';
const defaultSize = 'size.large';
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
    isLoading: {
        type: Boolean,
        default: false
    },
    isDisabled: {
        type: Boolean,
        default: false
    },
    isSuccess: {
        type: Boolean,
        default: false
    },
    color: {
        type: String as () => CommonButtonColorType,
        default: defaultColor
    },
    circle: {
        type: Boolean,
        default: false
    },
    size: {
        type: String as () => CommonButtonSizesType,
        default: defaultSize
    },
    widthFull: {
        type: Boolean,
        default: false
    }
});

const computedClasses = computed(() => {
    return [
        classMapping[props.size],
        classMapping[props.color]
    ];
});

const handleClick = (event: Event) => {
    if (props.isDisabled) {
        event.preventDefault();
        event.stopPropagation();
        return;
    }
};

</script>

<template>
  <div v-bind="$attrs"
       :class="['button-master cursor-pointer no-user-select', computedClasses, {'btn-disabled':isDisabled }, {'btn-circle':circle}, {'btn-success':isSuccess}, { 'pointer-events-none': isLoading }]"
       @click="handleClick"
  >
    <LoaderDots v-if="isLoading" />

    <div v-else-if="isSuccess">
      <IconMain :size="24"
                icon="check-mark"
      />
    </div>
    <slot v-else></slot>
  </div>
</template>
